import { render, staticRenderFns } from "./szdp1.vue?vue&type=template&id=fc010054&scoped=true&"
import script from "./szdp1.vue?vue&type=script&lang=js&"
export * from "./szdp1.vue?vue&type=script&lang=js&"
import style0 from "./szdp1.vue?vue&type=style&index=0&id=fc010054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc010054",
  null
  
)

export default component.exports